import type { AutomationBlockProps } from '../schemas/automation-model.js';

export const DEFAULT_CLEANUP_TIMEZONE = 'Europe/Berlin';

export function getCleanupSummary(
  props: Pick<
    AutomationBlockProps,
    | 'sourceTableName'
    | 'filterGroup'
    | 'triggerConfig'
    | 'lastRunAt'
    | 'lastRunStatus'
  >
) {
  const conditions = props.filterGroup?.conditions ?? [];
  const rule =
    conditions.length === 1 && conditions[0].type === 'filter'
      ? conditions[0]
      : null;
  const age = rule?.function === 'olderThanDays' ? rule.args[0] : null;
  const days =
    age?.type === 'literal' &&
    typeof age.value === 'number' &&
    Number.isSafeInteger(age.value) &&
    age.value > 0
      ? age.value
      : null;
  return {
    databaseName: props.sourceTableName,
    days,
    columnId: days === null ? null : rule?.left.name,
    ruleCount: conditions.length,
    enabled: props.triggerConfig?.enabled === true,
    timezone: props.triggerConfig?.timezone ?? DEFAULT_CLEANUP_TIMEZONE,
    preset: props.triggerConfig?.cronPreset,
    lastRunAt: props.lastRunAt,
    lastRunStatus: props.lastRunStatus,
  };
}

export function formatCleanupTimestamp(
  timestamp: number | null | undefined,
  timezone?: string
): string | null {
  if (timestamp == null || !Number.isFinite(timestamp)) return null;
  try {
    return new Date(timestamp).toLocaleString(undefined, {
      timeZone: timezone,
    });
  } catch {
    return null;
  }
}
